import { SkinItem, useUserAvatarId } from '@store'

import { useAvatarById } from './useAvatarById'

const DEFAULT_AVATAR: SkinItem = {
  id: 'default',
  name: 'Default',
  isAvailable: true,
  iconUrl: '/avatars/default_avatar.png',
  isSelected: true,
}

export const useUserAvatar = () => {
  const userAvatarId = useUserAvatarId()
  const { avatar: userAvatar } = useAvatarById({ avatarId: userAvatarId || '' })

  return { userAvatar: userAvatar || DEFAULT_AVATAR }
}
